// SettingsButton.js
import React from 'react'
import { useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import SettingsIcon from '@mui/icons-material/Settings'
import { useTranslation } from 'react-i18next'

const SettingsButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleConfigClick = () => navigate('/settings')

  return (
    <Tooltip title={t('openSettings')}>
      <IconButton onClick={handleConfigClick} color="inherit">
        <SettingsIcon />
      </IconButton>
    </Tooltip>
  )
}

export default SettingsButton
